import { COLORS, TYPOGRAPHY, SPACING, BORDER_RADIUS, SHADOWS } from "../constants/theme"

export const mainContainerStyle = {
	paddingLeft: SPACING.lg,
	paddingRight: SPACING.lg,
	margin: "0 auto",
	fontFamily: TYPOGRAPHY.fontFamily,
	color: COLORS.gray900,
}

export const headerSectionStyle = {
	display: "flex",
	justifyContent: "space-between",
	alignItems: "center",
	marginBottom: SPACING.lg,
}

export const headerTitleStyle = {
	margin: 0,
	fontSize: TYPOGRAPHY.fontSize.xl,
	fontWeight: TYPOGRAPHY.fontWeight.bold,
	color: COLORS.gray900,
	fontFamily: TYPOGRAPHY.fontFamily,
}

export const filterInputStyle = {
	border: `1px solid ${COLORS.borderDark}`,
	borderRadius: BORDER_RADIUS.md,
	padding: `${SPACING.sm} ${SPACING.sm}`,
	fontSize: TYPOGRAPHY.fontSize.sm,
	height: "40px",
	background: COLORS.white,
	color: COLORS.gray700,
	outline: "none",
	transition: "border-color 0.2s",
	fontFamily: TYPOGRAPHY.fontFamily,
}

export const filterSelectStyle = {
	...filterInputStyle,
	cursor: "pointer",
}

export const primaryButtonStyle = {
	background: COLORS.primary,
	color: COLORS.white,
	border: "none",
	borderRadius: BORDER_RADIUS.md,
	padding: `${SPACING.xs} ${SPACING.sm}`,
	fontSize: TYPOGRAPHY.fontSize.sm,
	fontWeight: TYPOGRAPHY.fontWeight.medium,
	cursor: "pointer",
	outline: "none",
	fontFamily: TYPOGRAPHY.fontFamily,
	transition: "all 0.2s ease",
}

export const secondaryButtonStyle = {
	...primaryButtonStyle,
	background: COLORS.white,
	color: COLORS.primary,
	border: `1px solid ${COLORS.primary}`,
}

export const tableStyle = {
	width: "100%",
	borderCollapse: "separate",
	borderSpacing: 0,
	background: COLORS.white,
	fontSize: TYPOGRAPHY.fontSize.sm,
	minWidth: "900px",
	boxShadow: SHADOWS.sm,
	marginBottom: 0,
	fontFamily: TYPOGRAPHY.fontFamily,
	borderRadius: BORDER_RADIUS.lg,
	overflow: "hidden",
}

export const thStyle = {
	padding: `${SPACING.sm} 10px`,
	borderBottom: `2px solid ${COLORS.border}`,
	fontWeight: TYPOGRAPHY.fontWeight.bold,
	background: COLORS.gray50,
	color: COLORS.gray800,
	textAlign: "left",
	fontSize: TYPOGRAPHY.fontSize.sm,
	fontFamily: TYPOGRAPHY.fontFamily,
}

export const tdStyle = {
	padding: `${SPACING.sm} 10px`,
	borderBottom: `1px solid ${COLORS.borderLight}`,
	color: COLORS.gray700,
	fontSize: TYPOGRAPHY.fontSize.sm,
	verticalAlign: "top",
	fontFamily: TYPOGRAPHY.fontFamily,
	background: COLORS.white,
}
